export default "__VITE_ASSET__Df2soZaf__"